import { httpClient } from "../index";
import { dispatch } from "../../state/store";
import { setNotificationCampaignDetails, setNotificationCampaigns } from "../../state/ducks";
import { fleetManagementUtil } from "../../utils";

const apiUrl = process.env.REACT_APP_SHARED_CORE_URL;

const getRequestData = (endpoint) => {
  return `${apiUrl}/${endpoint}`;
};

const fetchCampaigns = async () => {
  const url = getRequestData("notifications/campaign");

  const res = await httpClient.get(url);

  if (res?.data?.data) {
    dispatch(
      setNotificationCampaigns(
        fleetManagementUtil.filterFleetManagerNotificationCampaigns(res.data.data)
      )
    );
  }

  return res?.data?.data;
};

const fetchCampaignDetails = async (campaignName) => {
  const url = getRequestData(`user/campaignTracker?campaign_name=${campaignName}`);

  const res = await httpClient.get(url);

  if (res?.data?.data) {
    dispatch(setNotificationCampaignDetails(res?.data?.data));
  }
};

const createCampaign = async (notificationCampaign) => {
  const url = getRequestData("notifications/campaign");

  return await httpClient.post(url, { data: notificationCampaign });
};

const updateCampaign = async (notificationCampaign) => {
  const url = getRequestData("notifications/campaign");

  return httpClient.put(url, { data: notificationCampaign });
};

const deactivateCampaign = async (campaignName) => {
  const url = getRequestData(`notifications/campaign?campaignName=${campaignName}`);

  return httpClient.remove(url);
};

const notificationCampaignsService = {
  fetchCampaigns,
  createCampaign,
  fetchCampaignDetails,
  updateCampaign,
  deactivateCampaign
};

export default notificationCampaignsService;
